import * as React from 'react';
import { Button } from '@bytebrand/fe-ui-core-autobahn/ui';
import styles from './DealerTermCondModal.styl';
import FormTextArea from '../../../ui/FormTextArea/FormTextArea';
import ModalHeader from '../ModalHeader/ModalHeader';
import form, { fieldsNames } from '../../../pages/DealerPages/forms/DealerProfileForm';
class DealerTermCondModal extends React.PureComponent {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "onSave", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                form.$(fieldsNames.termCond).submit().then(({ isValid }) => {
                    if (isValid) {
                        this.props.hideModal('DEALER_TERM_COND_MODAL');
                    }
                });
            }
        });
        Object.defineProperty(this, "onDecline", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                form.$(fieldsNames.termCond).reset();
                this.props.hideModal('DEALER_TERM_COND_MODAL');
            }
        });
    }
    componentDidMount() {
        const { language, termsCond } = this.props;
        const field = form.$(fieldsNames.termCond);
        field.$(language).set(termsCond);
    }
    render() {
        const { t, language } = this.props;
        const field = form.$(fieldsNames.termCond);
        const languageField = field.$(language);
        return (React.createElement("div", { className: styles.wrapper },
            React.createElement("div", { className: styles.textHeader },
                React.createElement(ModalHeader, { t: t, field: field })),
            React.createElement("div", null,
                React.createElement(FormTextArea, { field: languageField, className: styles.textArea, fieldClassName: styles.textAreaField })),
            React.createElement("div", null,
                React.createElement("div", { className: styles.blockModalButton },
                    React.createElement(Button, { variant: 'outlined', className: styles.button, onClick: this.onDecline }, t('ui.button.discard')),
                    React.createElement(Button, { variant: 'filled', className: styles.button, onClick: this.onSave }, t('ui.button.save.default'))))));
    }
}
export default DealerTermCondModal;
